<template>
  <div v-if="sumoning.length" class="summoning-box">
    <SummoningOrderItem v-for="item of sumoning" :key="item.id" v-bind="item" />
  </div>
  <div v-else class="empty">
    <span>当前还没有召集中的活动发一个试试？</span>
    <button @click="goCreate">去发布</button>
  </div>
</template>
<script>
import SummoningOrderItem from '../../../components/SummoningOrderItem'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
export default {
  components: {
    SummoningOrderItem
  },
  data () {
    return {
      page: 1,
      size: 10,
      count: 0,
      sumoning: [],
      loading: false
    }
  },
  activated () {
    this.pageInit()
  },
  // mounted () {
  //   this.getSumoning()
  // },
  methods: {
    pageInit () {
      this.page = 1
      this.count = 0
      this.sumoning.length = 0
      this.getSumoning()
    },
    goCreate () {
      this.$router.push({
        path: '/exerland/createSummoningOrder'
      })
    },
    addUpRefresh () {
      const el = this.$refs.sumoning
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, sumoning, page } = this
          if (count > sumoning.length) {
            this.loading = true
            this.page = page + 1
            this.getSumoning()
          }
        }
      })
    },
    getSumoning () {
      const user = getUser('user')
      const { page, size } = this
      const promise = get({
        url: `/call/tales/${user.id}?page=${page}&size=${size}`
      })
      promise.then(res => {
        const {
          data: {
            code,
            detail: { count, list }
          }
        } = res
        if (Object.is(code, 200)) {
          this.count = count
          this.sumoning = [...this.sumoning, ...list]
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.summoning-box {
  box-sizing: border-box;
  height: 100vh;
  width: 100%;
  padding: 0 16px;
  overflow-y: scroll;
  margin-top: 13px;
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  span {
    width: 176px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(136, 136, 136, 1);
    line-height: 26px;
  }
  button {
    width: 132px;
    height: 44px;
    background: rgba(245, 245, 245, 1);
    border-radius: 4px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 24px;
    border: none;
    outline: none;
    margin-top: 25px;
  }
}
</style>
